import { ContentBlocks } from "eddev/blocks"
import { useAppData } from "eddev/hooks"

export function SiteFooter() {
  const footer = useAppData((data) => data.templateParts?.siteFooter?.contentBlocks)

  return <ContentBlocks blocks={footer} />
}
